module.exports = __webpack_public_path__ + "img/passage3d-light.094d9a8f.svg";